import EmptyScannerState from './ScannedItemsList/EmptyScannerState';
import { ScannedReturnShipping } from '../../models';
import ListHeader from './ScannedItemsList/ListHeader';
import ScannedItemCard from './ScannedItemCard';

interface ScannedItemsListProps {
  shippings: ScannedReturnShipping[];
  failedReasons: Record<number, string>;
  onRemove: (shippingNumber: number) => void;
}

const ScannedItemsList = ({
  shippings,
  failedReasons,
  onRemove,
}: ScannedItemsListProps) => {
  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8'>
      <ListHeader count={shippings.length} />
      <div className='flex flex-col gap-3 max-h-[600px] overflow-y-auto px-1'>
        {shippings.length === 0 ? (
          <EmptyScannerState />
        ) : (
          shippings.map((shipping, index) => (
            <ScannedItemCard
              key={shipping.shippingNumber}
              shipping={shipping}
              index={shippings.length - index}
              errorReason={failedReasons[shipping.shippingNumber]}
              onRemove={onRemove}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ScannedItemsList;
